// extracted by mini-css-extract-plugin
export var adjacentSlide = "_og-9";
export var arrowButtonContainer = "_og-5";
export var arrowButtonIcon = "_og-6";
export var carouselArrowButton = "_og-2";
export var carouselElementContainer = "_og-1";
export var currentSlide = "_og-8";
export var left = "_og-3";
export var otherSlide = "_og-a";
export var productCarouselContainer = "_og-0";
export var right = "_og-4";
export var sliderOverflow = "_og-7";